import {Component, Input} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector:'videoPlayer',
    templateUrl:'videoPlayer.component.html'
})
export class VideoPlayerComponent
{
    @Input() VideoUrl:string;

    constructor(private sanitizer: DomSanitizer){
        
    }

    getSefeUrl(){
        return this.sanitizer.bypassSecurityTrustResourceUrl(this.VideoUrl);
    }
}